export default "__VITE_ASSET__DV$lB2Kd__"